import * as React from 'react';
import * as QueryString from 'query-string';

interface ILabSimUserLinkProps {

}

interface ILabSimUserLinkState {
    error?: string;
    loading: boolean;
    searching: boolean;
    search?: string;
    labSimId?: string;
    users?: Array<IUserData>;
    completed: boolean;
    completedMessage?: string;
}

interface IInitUserData {
    name: string;
    labSimId: string;
    error: string;
}

interface IUserData {
    id: string;
    version: number;
    firstName: string;
    lastName: string;
    email: string;
    userType: string;
}

interface IUsersResponse {
    users: Array<IUserData>;
    error: string;
}

export default class LabSimUserLink extends React.PureComponent<ILabSimUserLinkProps, ILabSimUserLinkState> {
    constructor(props: ILabSimUserLinkProps) {
        super(props);
        this.state = { loading: true, searching: false, completed: false};
    }

    cancelForm() {
        window.parent.postMessage(JSON.stringify({ "action": "CANCEL" }), "*");
    }

    closeForm() {
        window.parent.postMessage(JSON.stringify({ "action": "DONE" }), "*");
    }

    select_Click(u : IUserData) {
        this.setState({ loading: true }, async () => {
            let q = QueryString.parse(window.location.search);
            let response = await fetch(`/api/labsim/userlink`, {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({
                    hubSpotId: q.hs_object_id,
                    labSimId: u.id
                })
            });
            let data = await response.json();
            if (data.error != null)
                this.setState({ loading: false, error: `Error while linking to the LabSim user: ${data.error}. Please try again, or contact IT for help.` });
            else this.setState({ loading: false, completed: true, completedMessage: "HubSpot and Dynamics 365 have been updated. The HubSpot Contact and CRM Contact are now linked to the LabSim user that was selected." });
        });
    }

    removeAssignment_Click() {
        this.setState({ loading: true }, async () => {
            let q = QueryString.parse(window.location.search);
            let response = await fetch(`/api/labsim/userlink/${q.hs_object_id}`, { method: "DELETE" });
            let data = await response.json();
            if (data.error != null)
                this.setState({ error: `Error while linking to the LabSim user: ${data.error}. Please try again, or contact IT for help.` });
            else this.setState({ loading: false, completed: true, completedMessage: "HubSpot and Dynamics 365 have been updated. This HubSpot Contact and the CRM Contact are now unlinked and not connected to any LabSim users." });
        });
    }

     doSearch_Click() {
        this.setState({searching: true}, async () => {
            let response = await fetch(`/api/labsim/usersearch?search=${encodeURIComponent(this.state.search || "")}`);
            let data = await response.json() as IUsersResponse;
            if (data.error != null)
                this.setState({ searching: false, error: `Error while searching for any LabSim users: ${data.error}. Please try again, or contact IT for help.` });
            else this.setState({ searching: false, users: data.users });
        });
    }

    async componentDidMount() {
        let response = await fetch(`/api/labsim/userinitdata${window.location.search}`);
        let data = await response.json() as IInitUserData;
        if (data.error != null)
            this.setState({ error: `Unable to retrieve the HubSpot contact data: ${data.error}. Please close and try again, or contact IT for help.` });
        else this.setState({ loading: false, search: data.name, labSimId: data.labSimId }, () => {
            this.doSearch_Click();
        });
    }

    render() {
        return <div>
                   {this.state.loading && <div className="spinner-border text-warning" style={{ "width": "10rem", "height": "10rem", "position": "absolute", "left": "calc(50% - 80px)", "top": "calc(50% - 125px)" }} role="status">
                <span className="sr-only">Loading...</span>
            </div>}
                   {!this.state.loading && <>
                {this.state.error != null && <div className="alert alert-danger text-center" id="cAlert">
                    <label>{this.state.error}</label>
                </div>}
                <div className="container" id="cSearch">
                    <p>Search for an existing LabSim user to link to this HubSpot Contact, or remove the current assignment.</p>
                    <div className="card">
                        <div className="card-title mb-0">
                            <div className="input-group bg-light">
                                <input className="form-control" type="text" id="tbSearch" value={this.state.search} onChange={(e) => { this.setState({ search: e.target.value }) }} onKeyPress={(e) => { if (e.key == "Enter") this.doSearch_Click() }} />
                                <div className="input-group-append">
                                    <button className="btn btn-outline-secondary" type="submit" id="btnSearch" onClick={() => { this.doSearch_Click() }}>Search</button>
                                </div>
                            </div>
                        </div>
                        <div className="card-body list-group bg-light p-4" id="dUsers">
                            {this.state.searching && <div style={{ "textAlign": "center" }}><div className="spinner-border text-warning" style={{ "width": "2rem", "height": "2em" }} role="status"><span className="sr-only">Searching...</span></div></div>}
                            {!this.state.searching && !this.state.completed && this.state.users != null && <>
                                {this.state.users.length > 0 && <>
                                    {this.state.users.map((u, idx) => {
                                        return <div key={idx} className="list-group-item">
                                            <div className="float-left">
                                                <div className="d-flex align-items-center"><strong>Name:</strong> <span className="ml-2 mr-1 h4 mb-0">{(u.version == 5 ? "➎" : "➏")}</span> {u.firstName} {u.lastName} <small className="ml-2">({u.userType})</small></div>
                                                <div><strong>Email:</strong> {u.email}</div>
                                            </div>
                                            <div className="float-right">
                                                <button className="btn btn-primary mt-3" onClick={() => { this.select_Click(u) }}>Select</button>
                                            </div>
                                        </div>;
                                    })}
                                </>}
                                {this.state.users.length == 0 && <>No LabSim Users were found matching the search terms.</>}
                            </>}
                        </div>
                    </div>
                    {!this.state.completed && <div className="container mt-2">
                        <button type="button" className="float-right btn btn-secondary ml-2" onClick={() => { this.cancelForm() }}>Cancel</button>
                        <button disabled={(this.state.labSimId || "") == ""} type="submit" className="float-right btn btn-outline-primary" id="btnRemoveAssignment" onClick={() => { this.removeAssignment_Click() }}>Remove Assignment</button>
                    </div>}
                </div>
                {this.state.completed && <div className="container" id="cComplete">
                    <div className="alert alert-success" role="alert">{this.state.completedMessage}</div>
                    <button type="button" className="float-right btn btn-primary ml-2" onClick={() => { this.closeForm() }}>Done</button>
                </div>}
            </>}
               </div>;
    }
}